/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptions {
    getFixupPrototypeFunction() { return FilterOptions.fixupPrototype; }

    static newInstance(model: Partial<FilterOptions>): FilterOptions {
        let obj = Object.assign(new FilterOptions(), model);
        FilterOptions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptions>): FilterOptions {
        if (!model) return null;
        return FilterOptions.newInstance(<FilterOptions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptions) {
        if (!obj) return;

        models.FilterOptions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptions): boolean {
        Object.setPrototypeOf(obj, FilterOptions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tenants) {
            for (let val of this.tenants) {
                models.FilterOptionsTenant.fixupPrototype(val);
            }
        }
    }

    tenants: Array<models.FilterOptionsTenant>;

}
